import React, {ReactNode} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {SxType} from "@baseTypes/sx/sxTypes";
import {sx} from './sx'

interface IProps {
    children?: ReactNode,
    fullWidth?: boolean,
    label?: string,
    sx?: SxType,
    variant?: 'secondary' | 'primary'
}

const LabelWrapperSingleVoyage = ({
                                      children,
                                      label,
                                      fullWidth,
                                      sx: sxProps = {},
                                      variant = 'primary'
                                  }: IProps) => {
    return (
        <Stack
            gap={variant === 'secondary' ? '5px' : '2px'}
            sx={{
                width: fullWidth ? '100%' : 'auto',
                ...sxProps,
            }}
            direction={variant === 'secondary' ? 'row' : 'column'}
            alignItems={!fullWidth && 'flex-start'}
        >
            {label && <Typography
                sx={sx.label}
                className={variant}
            >
                {label}
            </Typography>}
            {children}
        </Stack>
    );
};

export default LabelWrapperSingleVoyage;